import { Link } from 'react-router-dom'
import { legacyAppUrl } from '@/lib/api'
import { Alert, PageHeader, Section } from '@/components/ui'

type Props = {
  title: string
  matrixKey: string
  subtitle?: string
  legacyHash?: string
}

/** Página React mínima sem API estável — CTA para o Vanilla. */
export function StubModulePage({ title, matrixKey, subtitle, legacyHash }: Props) {
  const hash = legacyHash || `#/${matrixKey}`
  return (
    <section className="hi-page">
      <PageHeader
        title={title}
        subtitle={
          subtitle ||
          'Listagem React em preparação. O fluxo completo permanece no painel legado com o mesmo JWT.'
        }
        actions={
          <>
            <a className="btn btn-primary" href={legacyAppUrl(hash)}>
              Abrir no legado
            </a>
            <Link className="btn btn-secondary" to="/app">
              Voltar ao início
            </Link>
          </>
        }
      />
      <Section>
        <Alert tone="info">
          Módulo <strong>{matrixKey}</strong> disponível via deep-link em{' '}
          <code>/legado/index.html{hash}</code> até a API REST estar completa.
        </Alert>
      </Section>
    </section>
  )
}
